import type { HomePageVM, HomeSectionType, HomeSectionView, HomeSlot } from '../../../core/pages/home/types'
import { CLASSIC_HOME_SECTIONS } from './map'

/** Render one slot through its section view (today's renderSection). */
export function HomeSection({ slot, vm }: { slot: HomeSlot; vm: HomePageVM }) {
  const View = CLASSIC_HOME_SECTIONS[slot.type as HomeSectionType] as HomeSectionView<HomeSectionType> | undefined
  if (!View) return null
  return <View slot={slot} data={vm.data[slot.type] as never} vm={vm} />
}
